module.exports = "/assets/about/success/fba2020.png?HH6wpdY";